// extracted by mini-css-extract-plugin
export var editInput = "_er-0";
export var editInputCompact = "_er-2";
export var editInputLarge = "_er-1";
export var editInputSmall = "_er-3";